import { Sphere } from '@react-three/drei';
import { useAtomValue } from 'jotai';

import { activeData3dAtom, comparisonData3dAtom } from '@store';
import { colors } from '@ui';

// Golf ball diameter is 42.7mm, radius is 21.35mm
export const GOLF_BALL_RADIUS = 0.02135;

type GolfBallProps = {
    origin?: string;
};

const CURRENT = 'current';

export const GolfBall = ({ origin }: GolfBallProps) => {
    const data = useAtomValue(origin === CURRENT ? activeData3dAtom : comparisonData3dAtom);

    if (!data?.golfBallTranslation) {
        return null;
    }
    return (
        <Sphere args={[GOLF_BALL_RADIUS]} position={data?.golfBallTranslation}>
            <meshStandardMaterial color={colors.slate[400]} transparent opacity={0.5} />
        </Sphere>
    );
};
